import sedanImg from "../assets/img/common/modelos/k3-sedan.webp";
import crossImg from "../assets/img/common/modelos/k3-cross.webp";
import SeltosImg from "../assets/img/common/modelos/Seltos.webp";
import SportageImg from "../assets/img/common/modelos/Sportage.webp";
import carnivalImg from "../assets/img/common/modelos/Carnival.webp";
import k2500Img from "../assets/img/common/modelos/K2500.webp";
import k4Img from "../assets/img/common/modelos/k4-sedan.webp";
import TasmanImg from "../assets/img/common/modelos/tasman.webp";
import k4HatchbackImg from "../assets/img/common/modelos/k4-hatchback.webp";
import SorentoImg from "../assets/img/common/modelos/Sorento.webp";

const CAR_MODELS = [
  {
    id: 29,
    name: "K4 Hatchback",
    image: k4HatchbackImg,
  },
  {
    id: 27,
    name: "Tasman",
    image: TasmanImg,
  },
  {
    id: 28,
    name: "Sorento",
    image: SorentoImg,
  },
  {
    id: 26,
    name: "Nuevo K4 Sedán",
    image: k4Img,
  },
  {
    id: 24,
    name: "K3 Sedán",
    image: sedanImg,
  },
  {
    id: 25,
    name: "K3 Cross",
    image: crossImg,
  },
  {
    id: 23,
    name: "Seltos",
    image: SeltosImg,
  },
  {
    id: 1,
    name: "Sportage",
    image: SportageImg,
  },
  {
    id: 7,
    name: "Carnival",
    image: carnivalImg,
  },
  {
    id: 8,
    name: "K2500",
    image: k2500Img,
  },
];

export default CAR_MODELS;
